/**
 * Standalone Plantillas hub — v1.2 (Feb 2026).
 * Renders Admin with the templates tab preselected via `defaultTab`.
 */
import React from 'react';
import Admin from './Admin';

export default function Plantillas() {
  return <Admin defaultTab="templates" />;
}
